import React, { useEffect, useState } from "react"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import Chip from "@material-ui/core/Chip"
import useStyles from "./QueueSelectStyles"
import { Skeleton } from "@material-ui/lab"
import { useTheme } from "@material-ui/core"
import { pegarCorDeFundo } from "../../helpers/pegarCorDeFundo"
import pegarCorPrimaria from "../../helpers/pegarCorPrimaria"
import { useFilaStore } from "../../stores/filaStore"

const QueueSelect = ({
  modalOpen,
  selectedQueueIds,
  onChange,
  multiple = true,
  title = "Filas",
  error,
  helperText,
  allowedQueueIds,
}) => {
  const classes = useStyles()
  const { filas, fetchFilas } = useFilaStore()
  const [loading, setLoading] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    if (!modalOpen) return
    setLoading(true)
    const timer = setTimeout(() => {
      fetchQueues()
      setLoading(false)
    }, 200)
    return () => clearTimeout(timer)
  }, [])

  const fetchQueues = async () => {
    await fetchFilas()
  }

  const handleChange = (e) => {
    onChange(e.target.value)
  }

  const mFilasExibidas = Array.isArray(allowedQueueIds)
    ? filas.filter((queue) => allowedQueueIds.includes(queue.id))
    : filas

  if (loading) {
    return (
      <div>
        <FormControl fullWidth variant="outlined">
          <Skeleton animation="wave" height={60} />
        </FormControl>
      </div>
    )
  }

  return (
    <div style={{ marginBottom: 24 }}>
      <FormControl
        fullWidth
        variant="outlined"
        style={{ backgroundColor: theme.palette.background100, borderRadius: 12 }}
        error={error}
      >
        <InputLabel>{title}</InputLabel>

        <Select
          label={title}
          multiple={multiple}
          labelWidth={60}
          value={selectedQueueIds}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
          style={{ borderRadius: 12 }}
          renderValue={(selected) => {
            // Tratamento para garantir que selected seja sempre um array.
            const mSelecionados = Array.isArray(selected) ? selected : [selected]

            return (
              <div className={classes.chips}>
                {mSelecionados.map((nFilaId) => {
                  const oFila = filas.find((q) => q.id === nFilaId)
                  return oFila ? (
                    <Chip
                      key={nFilaId}
                      style={{ backgroundColor: pegarCorDeFundo(oFila.color), color: pegarCorPrimaria(oFila.color) }}
                      label={oFila.name}
                      className={classes.chip}
                    />
                  ) : null
                })}
              </div>
            )
          }}
        >
          {!multiple && <MenuItem value={null}>Nenhum</MenuItem>}
          {mFilasExibidas.map((queue) => (
            <MenuItem key={queue.id} value={queue.id}>
              {queue.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {helperText && (
        <div className={error ? classes.errorField : classes.helperText}>{helperText}</div>
      )}
    </div>
  )
}

export default QueueSelect
